// 1. Imports
import "./SwipeableModals.scss";
import { Rating } from "@mui/material";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import ShopPhoto from "./../../../assets/shop-img.png";
import ProductPhoto from "./../../../assets/product-img.png";
import StarIcon from "@mui/icons-material/Star";

// 2. Main Component
const SwipeableModals = ({
  open,
  onClose,
  onOpen,
  currentView,
  comments = [],
  commentData = null,
}) => {
  const safeNumber = (val, fallback = 0) => {
    const n = Number(val);
    return Number.isFinite(n) ? n : fallback;
  };

  const renderUserRatesView = () => {
    // If we don't have a selected comment yet, show a minimal placeholder
    if (!commentData) {
      return (
        <div className="user-modal">
          <p className="user-modal-p">عرض التقييم</p>
          <div className="shop">
            <p className="title">لا يوجد تقييم محدد</p>
            <p className="rate-text">اختر تقييماً من الجدول لعرض التفاصيل.</p>
          </div>
        </div>
      );
    }

    const {
      vendor,
      logo,
      vendor_rating,
      vendor_comment,
      vendor_replied_comment,
      product,
      product_images,
      rating,
      comment,
    } = commentData || {};

    const productImage =
      (Array.isArray(product_images) && product_images[0]?.image_path) ||
      ProductPhoto;
    const shopLogo = logo || ShopPhoto;

    return (
      <div className="user-modal">
        <p className="user-modal-p">عرض التقييم</p>

        {/* المتجر */}
        <div className="shop">
          <p className="title">المتجر</p>
          <div className="img-container">
            <img src={shopLogo} alt="" />
            <p className="name">{vendor || "—"}</p>
          </div>
          <Rating
            name="vendor-rating"
            value={safeNumber(vendor_rating, 0)}
            readOnly
            precision={0.5}
            emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="10px" />}
          />
          {vendor_comment || vendor_replied_comment ? (
            <p className="rate-text">
              {vendor_comment || vendor_replied_comment}
            </p>
          ) : null}
        </div>

        {/* المنتج */}
        <div className="shop">
          <p className="title">المنتج</p>
          <div className="img-container">
            <img src={productImage} alt="" />
            <p className="name">{product || "—"}</p>
          </div>
          <Rating
            name="product-rating"
            value={safeNumber(rating, 0)}
            readOnly
            precision={0.5}
            emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="10px" />}
          />
          {comment ? <p className="rate-text">{comment}</p> : null}
        </div>
      </div>
    );
  };

  const renderDefaultView = () => <div></div>;

  const views = {
    userRates: renderUserRatesView,
  };

  return (
    <SwipeableDrawer
      anchor="left"
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      sx={{ zIndex: "1202" }}
      disableScrollLock
    >
      {(views[currentView] || renderDefaultView)()}
    </SwipeableDrawer>
  );
};

export default SwipeableModals;
